import type { TourDefinition } from "../types";

/**
 * Tour for /app/asset-library. Explains how approved visuals land here and
 * how to download finished deliverables.
 */
export const assetLibraryTour: TourDefinition = {
  id: "asset-library",
  label: "Asset Library",
  description: "Where approved visuals & deliverables live",
  routeMatch: /^\/app\/asset-library\/?$/,
  path: "/app/asset-library",
  estimatedSeconds: 40,
  steps: [
    {
      target: "body",
      placement: "center",
      title: "Your Asset Library",
      body: "Every visual you approve in Studio automatically shows up here, grouped by product. This is your canonical, downloadable library.",
    },
    {
      target: '[data-tour="asset-library.search"]',
      placement: "bottom-start",
      title: "Search assets",
      body: "Filter by product or brief name. Great when you need to grab a specific hero shot quickly.",
      showIf: () => !!document.querySelector('[data-tour="asset-library.search"]'),
    },
    {
      target: '[data-tour="asset-library.sections"]',
      placement: "top",
      title: "Grouped by product",
      body: "Each section collapses independently. Under each approved visual you'll see all the export formats we generated — click any to preview or download.",
      showIf: () => !!document.querySelector('[data-tour="asset-library.sections"]'),
    },
  ],
};
